<template>
    <div class="cms-container mb-4">
        <ToastCMS ref="toast" />

        <!-- PREVIEW MODAL -->
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>
                    <div class="d-flex justify-content-between align-items-center border-0">
                        <video v-if="previewIsVideo" :src="previewSrc" controls muted
                            style="max-width:70vw; max-height:70vh; display:block; margin:0 auto;"></video>
                        <img v-else :src="previewSrc" alt="Preview">
                    </div>
                </div>
            </div>
        </div>

        <div class="sticky-controls">
            <div class="main-header d-flex align-items-center justify-content-between px-3">
                <div class="contact-header text-dark">Contact Numbers</div>
                <button type="button" @click="clearText"
                    class="vmc-bg-prime-6 text-white rounded px-2 py-1 border-0">Clear
                    Inputs</button>
            </div>
        </div>

        <!-- BACKGROUND MEDIA — separate from form -->
        <div class="px-3">
            <div class="mt-3">
                <div class="d-flex align-items-center justify-content-between w-100 my-2">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="bg-media-header text-dark">
                            Background Media (MP4 or Image, Max 10MB)
                        </span>
                        <div class="d-flex align-items-center" style="gap:5px;">
                            <button type="button" @click="previewBgMedia"
                                class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                View
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    style="height:200px; width:100%; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;">
                    <video v-if="contactBackgroundVideo" :src="contactBackgroundVideo" class="w-100 h-100" controls
                        muted style="object-fit:contain;"></video>
                    <img v-else-if="contactBackgroundImage" :src="contactBackgroundImage" class="w-100 h-100"
                        style="object-fit:contain;">
                    <template v-else>
                        <input type="file" id="upload-contact-bg" accept="video/mp4, image/png, image/jpeg, image/jpg"
                            hidden @change="onBgMediaChange($event)">
                        <label for="upload-contact-bg"
                            class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                            style="cursor:pointer;">
                            <i class="material-symbols-outlined">upload</i>
                            <span>Upload Background (MP4 or Image)</span>
                        </label>
                    </template>
                </div>
                <button @click="removeBgMedia" type="button"
                    class="w-100 vmc-bg-prime-6 py-1 text-white mt-1 border-0 rounded">
                    Remove Media
                </button>
            </div>
        </div>

        <form action="" id="contacts" @submit.prevent="saveAllChanges">
            <div class="px-3 mt-4">
                <label class="text-dark address-label">Full Address</label>
                <textarea class="w-100 text-dark p-2 mt-1" rows="2" v-model="address"
                    style="border:1px solid gray; border-radius:4px; outline:none; font-size:15px; resize:none;"></textarea>
            </div>

            <div class="grid-header px-3 d-block d-sm-flex">
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="globenumber">
                    <label class="floating-label">Hotline 1</label>
                </div>
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="smartnumber">
                    <label class="floating-label">Hotline 2</label>
                </div>
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="faxnumber">
                    <label class="floating-label">Fax Number</label>
                </div>
            </div>

            <div class="grid-header px-3 d-block d-sm-flex">
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="pcc">
                    <label class="floating-label">PCC Division</label>
                </div>
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="bulk">
                    <label class="floating-label">Bulk Position</label>
                </div>
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="docs">
                    <label class="floating-label">Docs Division</label>
                </div>
            </div>

            <div class="grid-header px-3 d-block d-sm-flex">
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="training">
                    <label class="floating-label">Training Division</label>
                </div>
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="accounting">
                    <label class="floating-label">Accounting Dept 1</label>
                </div>
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="accounting2">
                    <label class="floating-label">Accounting Dept 2</label>
                </div>
            </div>

            <div class="grid-header px-3 d-block d-sm-flex">
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="execOffices">
                    <label class="floating-label">Executive Offices</label>
                </div>
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="adminDept">
                    <label class="floating-label">Admin Department</label>
                </div>
            </div>

            <div class="grid-header px-3 d-block d-sm-flex">
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="email1">
                    <label class="floating-label">Email Address 1</label>
                </div>
                <div class="input-group">
                    <input type="text" class="input-field w-100 text-dark p-2" placeholder="" v-model="email2">
                    <label class="floating-label">Email Address 2</label>
                </div>
            </div>

            <!-- ── NEW: Resume receiving email ─────────────────────── -->
            <!-- <div class="px-3 mt-2">
                <div class="resume-email-section">
                    <div class="resume-email-label">
                        <i class="material-symbols-outlined"
                            style="font-size:18px; vertical-align:middle; margin-right:5px;">mark_email_unread</i>
                        Resume Receiving Email Address
                        <span class="resume-email-hint">— Job applications submitted on the website will be forwarded
                            here.</span>
                    </div>
                    <div class="input-group mt-0">
                        <input type="email" class="input-field w-100 text-dark p-2" placeholder=""
                            v-model="resumeEmail">
                        <label class="floating-label">Resume Receiving Email</label>
                    </div>
                </div>
            </div> -->
            <!-- ── END: Resume receiving email ────────────────────── -->

        </form>

        <div class="px-3">
            <button type="submit" form="contacts" class="vmc-bg-prime-4 border-0 rounded text-white mt-4 px-3 py-1">
                Save all Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "ContactUsCMS",
    components: {
        ToastCMS
    },
    data() {
        return {
            /* Backend field names used directly */
            address: '',
            globenumber: '',
            smartnumber: '',
            faxnumber: '',
            pcc: '',
            bulk: '',
            docs: '',
            training: '',
            accounting: '',
            accounting2: '',
            execOffices: '',
            adminDept: '',
            email1: '',
            email2: '',
            resumeEmail: '',           // ← NEW
            contactBackgroundVideo: '',
            contactBackgroundImage: '',

            /* Snapshots */
            originalAddress: '',
            originalGlobenumber: '',
            originalSmartnumber: '',
            originalFaxnumber: '',
            originalPcc: '',
            originalBulk: '',
            originalDocs: '',
            originalTraining: '',
            originalAccounting: '',
            originalAccounting2: '',
            originalExecOffices: '',
            originalAdminDept: '',
            originalEmail1: '',
            originalEmail2: '',
            originalResumeEmail: '',   // ← NEW
            originalContactBgVideo: '',
            originalContactBgImage: '',

            previewSrc: null,
            previewIsVideo: false,
            showPreviewModal: false
        }
    },
    methods: {
        clearText() {
            const isEmpty = [
                this.address,
                this.globenumber, this.smartnumber, this.faxnumber, this.pcc,
                this.bulk, this.docs, this.training, this.accounting,
                this.accounting2, this.execOffices, this.adminDept, this.email1, this.email2
                // resumeEmail intentionally excluded from clear
            ].every(v => !v || v.trim() === "");

            this.address = "";
            this.globenumber = ""; this.smartnumber = ""; this.faxnumber = "";
            this.pcc = ""; this.bulk = ""; this.docs = "";
            this.training = ""; this.accounting = ""; this.accounting2 = "";
            this.execOffices = ""; this.adminDept = "";
            this.email1 = ""; this.email2 = "";
            // resumeEmail intentionally not cleared

            this.$refs.toast.showToast(isEmpty ? "Has no input" : "Cleared All Inputs", isEmpty ? "warning" : "error");
        },

        async onBgMediaChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
        this.$refs.toast.showToast("File is too large! Max 10MB.", "error");
        e.target.value = "";
        return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch('/vmc/api/upload', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            if (file.type.startsWith('video/')) {
                this.contactBackgroundVideo = data.url;
                this.contactBackgroundImage = '';
            } else {
                this.contactBackgroundImage = data.url;
                this.contactBackgroundVideo = '';
            }
            this.$refs.toast.showToast("Background media attached", "success");
        } else {
            console.error("Upload failed:", data.message);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }

    e.target.value = "";
},

        previewBgMedia() {
            if (!this.contactBackgroundVideo && !this.contactBackgroundImage) {
                this.$refs.toast.showToast("No background media to view", "warning");
                return;
            }
            if (this.contactBackgroundVideo) {
                this.previewSrc = this.contactBackgroundVideo;
                this.previewIsVideo = true;
            } else {
                this.previewSrc = this.contactBackgroundImage;
                this.previewIsVideo = false;
            }
            this.showPreviewModal = true;
        },

        removeBgMedia() {
            if (!this.contactBackgroundVideo && !this.contactBackgroundImage) {
                this.$refs.toast.showToast("No background media to remove", "warning");
                return;
            }
            this.contactBackgroundVideo = '';
            this.contactBackgroundImage = '';
            this.$refs.toast.showToast("Background media removed", "error");
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewSrc = null;
            this.previewIsVideo = false;
        },

        onKeyboard(e) {
            if (this.showPreviewModal && e.key === 'Escape') {
                this.showPreviewModal = false;
            }
        },

        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Failed to fetch content");

                const data = await response.json();

                if (data && Object.keys(data).length > 0) {
                    this.address = data.address ?? '';
                    this.globenumber = data.globenumber ?? '';
                    this.smartnumber = data.smartnumber ?? '';
                    this.faxnumber = data.faxnumber ?? '';
                    this.pcc = data.pcc ?? '';
                    this.bulk = data.bulk ?? '';
                    this.docs = data.docs ?? '';
                    this.training = data.training ?? '';
                    this.accounting = data.accounting ?? '';
                    this.accounting2 = data.accounting2 ?? '';
                    this.execOffices = data.execOffices ?? '';
                    this.adminDept = data.adminDept ?? '';
                    this.email1 = data.email1 ?? '';
                    this.email2 = data.email2 ?? '';
                    this.resumeEmail = data.resumeEmail ?? '';  // ← NEW
                    this.contactBackgroundVideo = data.contactBackgroundVideo ?? '';
                    this.contactBackgroundImage = data.contactBackgroundImage ?? '';
                }

                /* Snapshots */
                this.originalAddress = this.address;
                this.originalGlobenumber = this.globenumber;
                this.originalSmartnumber = this.smartnumber;
                this.originalFaxnumber = this.faxnumber;
                this.originalPcc = this.pcc;
                this.originalBulk = this.bulk;
                this.originalDocs = this.docs;
                this.originalTraining = this.training;
                this.originalAccounting = this.accounting;
                this.originalAccounting2 = this.accounting2;
                this.originalExecOffices = this.execOffices;
                this.originalAdminDept = this.adminDept;
                this.originalEmail1 = this.email1;
                this.originalEmail2 = this.email2;
                this.originalResumeEmail = this.resumeEmail;           // ← NEW
                this.originalContactBgVideo = this.contactBackgroundVideo;
                this.originalContactBgImage = this.contactBackgroundImage;

            } catch (error) {
                console.error("Load error:", error);
                this.$refs.toast.showToast("Failed to load data!", "error");
            }
        },

        async saveAllChanges(e) {
            e.preventDefault();

            if (!this.hasChanges) {
                this.$refs.toast.showToast("Nothing to save", "warning");
                return;
            }

            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        address: this.address,
                        globenumber: this.globenumber,
                        smartnumber: this.smartnumber,
                        faxnumber: this.faxnumber,
                        pcc: this.pcc,
                        bulk: this.bulk,
                        docs: this.docs,
                        training: this.training,
                        accounting: this.accounting,
                        accounting2: this.accounting2,
                        execOffices: this.execOffices,
                        adminDept: this.adminDept,
                        email1: this.email1,
                        email2: this.email2,
                        resumeEmail: this.resumeEmail,            // ← NEW
                        contactBackgroundVideo: this.contactBackgroundVideo,
                        contactBackgroundImage: this.contactBackgroundImage
                    })
                });

                if (!response.ok) throw new Error("Server error");

                /* Update snapshots */
                this.originalAddress = this.address;
                this.originalGlobenumber = this.globenumber;
                this.originalSmartnumber = this.smartnumber;
                this.originalFaxnumber = this.faxnumber;
                this.originalPcc = this.pcc;
                this.originalBulk = this.bulk;
                this.originalDocs = this.docs;
                this.originalTraining = this.training;
                this.originalAccounting = this.accounting;
                this.originalAccounting2 = this.accounting2;
                this.originalExecOffices = this.execOffices;
                this.originalAdminDept = this.adminDept;
                this.originalEmail1 = this.email1;
                this.originalEmail2 = this.email2;
                this.originalResumeEmail = this.resumeEmail;           // ← NEW
                this.originalContactBgVideo = this.contactBackgroundVideo;
                this.originalContactBgImage = this.contactBackgroundImage;

                this.$refs.toast.showToast("Saved all changes.", "success");
                setTimeout(() => { window.location.reload(); }, 1500);

            } catch (error) {
                console.error("Save error:", error);
                this.$refs.toast.showToast("Save failed. Check your connection.", "error");
            }
        }
    },

    async mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        await this.loadFormData();
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
    },

    computed: {
        hasChanges() {
            return (
                this.address !== this.originalAddress ||
                this.globenumber !== this.originalGlobenumber ||
                this.smartnumber !== this.originalSmartnumber ||
                this.faxnumber !== this.originalFaxnumber ||
                this.pcc !== this.originalPcc ||
                this.bulk !== this.originalBulk ||
                this.docs !== this.originalDocs ||
                this.training !== this.originalTraining ||
                this.accounting !== this.originalAccounting ||
                this.accounting2 !== this.originalAccounting2 ||
                this.execOffices !== this.originalExecOffices ||
                this.adminDept !== this.originalAdminDept ||
                this.email1 !== this.originalEmail1 ||
                this.email2 !== this.originalEmail2 ||
                this.resumeEmail !== this.originalResumeEmail ||  // ← NEW
                this.contactBackgroundVideo !== this.originalContactBgVideo ||
                this.contactBackgroundImage !== this.originalContactBgImage
            );
        }
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

hr {
    border-top: 1px solid black;
}

.sticky-controls {
    position: sticky;
    z-index: 1;
    background-color: white;
}

/* ── Resume email section ───────────────────────────── */
.resume-email-section {
    border: 1.5px solid #1a52a0;
    border-radius: 8px;
    padding: 14px 16px 16px;
    background: #f0f4ff;
    margin-top: 8px;
    margin-bottom: 8px;
}

.resume-email-label {
    font-size: 14px;
    font-weight: 600;
    color: #1a2a4a;
    margin-bottom: 10px;
}

.resume-email-hint {
    font-weight: 400;
    color: #555;
    font-size: 12px;
}

@media (min-width: 330px) {
    .main-header {
        padding: 15px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .contact-header,
    .address-label {
        font-size: 17px;
    }

    .bg-media-header {
        font-size: 18px;
    }

    .contact-header,
    .bg-media-header,
    .address-label {
        font-weight: 600;
    }

    .grid-header {
        gap: 10px;
    }

    input {
        font-size: 15px;
        resize: none;
        outline: none;
        height: 36px;
    }

    .input-group {
        position: relative;
        display: flex;
        margin-top: 25px;
    }

    .input-field {
        border: 1px solid gray;
        border-radius: 4px !important;
        width: 100%;
        outline: none;
    }

    .floating-label {
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        color: gray;
        background-color: white;
        transition: all 0.3s ease;
        pointer-events: none;
    }

    .input-field:focus~.floating-label,
    .input-field:not(:placeholder-shown)~.floating-label {
        top: 0;
        left: 8px;
        transform: translateY(-50%);
        font-size: 12px;
    }

    button {
        transition: 0.3s;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .modal-content img,
    .modal-content video {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }

    .sticky-controls {
        top: 60px;
    }
}

@media (min-width: 768px) {
    .contact-header {
        font-size: 20px;
    }
}

@media (min-width: 992px) {}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .sticky-controls {
        top: 82px;
    }
}
</style>